import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { em } from "@util/convertUnits";

import { useTheme } from "@emotion/react";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useContext } from 'react';
import { ProductContext } from "@/core/providers/ProductContext";
import { useSchema } from "../providers/SchemaContext";
import { BreadcrumbContext } from "../providers/BreadcrumbContext";



const BreadcrumbsNav = () => {

    const { breadcrumbs} = useContext(BreadcrumbContext);

    const { addBreadCrumbSchema, fullSchema } = useSchema();

    const theme = useTheme();

    const homeTitle = "LaCantina";

    useEffect(() => {

        if(breadcrumbs && fullSchema && !fullSchema.breadcrumb){

            //lets add the home item to the breadcrumbs from here
            const breadcrumSchema = {
                "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": homeTitle,
                        "item": "/"
                    },
                    ...breadcrumbs.map((breadcrumb, index) => { 
                        return {
                            "@type": "ListItem",
                            "position": index + 2,
                            "name": breadcrumb.label,
                            "item": breadcrumb.path
                        }
                    })
                ],
              }
            };
            
            addBreadCrumbSchema(breadcrumSchema)

        }

    }, [fullSchema, addBreadCrumbSchema]);

    const breadcrumbsNavStyle = css`
        padding: 1em;
        font-size: 13px;
        background-color: #666666; 
        @media (min-width: ${em(theme.mobileNavBp, 16)}) {
            display: flex;
            -moz-box-align: center;
            align-items: center;
            -moz-box-pack: center;
            justify-content: center;
            width: 100%;
            margin: 0px auto;
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
        }

        li{
            margin: 0;
        }
    `;

    const breadCrumbsNavLink = css`
        display: inline-block;
        padding-left: 5px;
        padding-right: 5px;
        color: #ffffff;
        text-decoration: none;
        text-transform: capitalize;
        &:hover {
            color: #ffffff;
            text-decoration: underline;
        }
    `;

    const breadcrumbArrow = css `
        display: inline-block;
        padding-left: 5px;
        padding-right: 5px;
        color: #ffffff;
        text-transform: capitalize;
    `;

    const linkOrLabel = (breadcrumb, index) => {
        if(index === breadcrumbs.length - 1 || breadcrumb.path === "" ){
            return <div className="breadCrumbsNavLink" css={breadcrumbArrow}>{breadcrumb.label}</div>
        } else {
            return <Link to={breadcrumb.path} css={breadCrumbsNavLink}>{breadcrumb.label}</Link>
        }
    }

    const buildListItems = () => {

        let items = [];

        items.push(
            <li key={0}>
                <Link to="/" css={breadCrumbsNavLink}>{homeTitle}</Link>
                <div className="breadcrumbArrow" css={breadcrumbArrow}>&gt;</div>
            </li>
        );

        breadcrumbs.map((breadcrumb, index) => {
            items.push(
                <li key={index+1}>
                    {linkOrLabel(breadcrumb, index)}
                    {index < breadcrumbs.length - 1 && <div className="breadcrumbArrow" css={breadcrumbArrow}>&gt;</div>}
                </li>
            );
        });

        return items;
    }

  return breadcrumbs ? (
    <nav className="flex-grow-1" css={breadcrumbsNavStyle}>
        <ul>
            {buildListItems()}
        </ul>
    </nav>
  ) : <></>;
};

BreadcrumbsNav.propTypes = {
    bp: PropTypes.number,
};

export default BreadcrumbsNav;
